module.exports = __webpack_public_path__ + "static/media/identity-tbd-web.bc223d0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/identity-tbd-web.jpg
// module id = 262
// module chunks = 0